import { Observable } from 'rxjs';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { AdviDTO } from '../../../../dto/advi/advi.dto';
import { environment } from '../../../../environment/environment';

export const updateAdvisory = (dataDestService: any, componentDataSourceService: ComponentDataSourceService) => {
  return (data: Partial<AdviDTO> & { advi_id: number }): Observable<any> => {

    const { advi_id, ...updateData } = data;

    // For snapshot reports the backend expects path_ids and report_config;
    // for scheduled reports it expects recipient_user_ids and advisory_intervals.
    // We simply forward all provided fields and let the backend validate.
    return dataDestService.http.put(
      `${environment.apiUrl}/advi/${advi_id}`,
      updateData
    );
  };
};
